<template lang="pug">
  b-field.select-label(:label="label")
    b-dropdown(v-model="innerData" @change="changeValue")
      b-field.has-addons(slot="trigger")
        .control
          //-ui-label(v-if="innerData" :label="innerData" button icon-right="menu-down")
          template(v-if="innerData")
            b-button
              | {{innerData.title}}
          b-button.has-text-grey(v-else icon-right="menu-down") Не выбрана

        .control(v-if="withReset && innerData"): b-button.o-9(icon-left="close" @click.stop="changeValue(null)" :type="innerData.labelColor")

      b-dropdown-item(v-for="role in roles.items" :key="role.id" :value="role")
        span {{role.title}}
</template>

<script>
import Role from '@/models/Role';

export default {
  name: 'select-role',

  props: {
    value: [String, Number],
    role: Object,
    label: String,
    withReset: Boolean,
    type: String,
  },

  data: () => ({
    roles: Role.collection(),
    innerData: null,
  }),

  watch: {
    value(roleId) {
      this.updateInnerData(null, roleId);
    },
  },

  methods: {
    async loadState() {
      await this.roles.$fetch({
        //include: '',
        // filter: { type: this.type },
        sort: 'name',
      });
      this.$emit('onLoadState', this.roles);
    },

    changeValue(role) {
      this.$emit('input', role ? role.id : null);
      this.$emit('update:role', role);
    },

    updateInnerData(role, roleId) {
      if (role) {
        this.innerData = role;
      } else if (this.roles) {
        this.innerData = this.roles.find(roleId);
      }
    },
  },

  async created() {
    this.updateInnerData(this.role);
    await this.loadState();
    if (!this.role) {
      this.updateInnerData(null, this.value);
    }
  },
};
</script>
